export default __webpack_public_path__ + "static/media/ic-home-account.43847764.svg";